export default angular.module('contartemx.animaciones', [])
  .directive('animacionCampana', ($animate) => {

    return {
      restrict: 'A',
      link: function (scope, elem, attrs) {

        elem.on('mouseover click', function () {
          var self = angular.element(this).find('.icon');

          let promesa;

          if (promesa) $animate.cancel(promesa);

          promesa = $animate.addClass(self, 'animacion-campana')
            .then(() => $animate.removeClass(self, 'animacion-campana'));

        });

      }
    }

  });
